import { defineStore } from 'pinia'
import { ref } from 'vue'
import { axiosClient, isUserGlobalAdmin, userAzureId } from "@/helpers/auth";
import { useGlobalStore } from "@/store/storeGlobal";
import { useNotificationsStore } from "@/store/notificationsStore";

export const useIcs4Store = defineStore('ics4Store', () =>
{

  const globalStore = useGlobalStore();
  const notificationsStore = useNotificationsStore();


  let fetching = false;
  const isAuth = ref(false);
  const userName = ref('');
  const isGlobalAdmin = ref(false);
  const curUserDbsAndRoles = ref(null);  // All databases with roles for user

  const debugPrefix = '[Ics4]';

  async function loadDbsAndRole ()
  {
    console.log('loadDbsAndRole()', curUserDbsAndRoles.value != null || fetching);
    if (curUserDbsAndRoles.value != null || fetching) {
      return;
    }

    fetching = true;
    await notificationsStore.addInfo("Laster oppsett");

    try {
      if (userAzureId.value !== "") {
        isGlobalAdmin.value = await isUserGlobalAdmin();
        const res = await axiosClient.get('user-databases');
        curUserDbsAndRoles.value = res.data || [];
      } else {
        curUserDbsAndRoles.value = null;
      }
    } finally {
      fetching = false;
    }
  }


  async function hasAccessToDatabaseObject (systemObjectId)
  {
    console.log('hasAccessToDatabaseObject', systemObjectId);
    const result = await axiosClient.get('object-access-list');
    const accessList = result.data;
    globalStore.debug(`${debugPrefix} accessList: `, accessList);
    const hasAccess = accessList.includes(parseInt(systemObjectId));
    globalStore.debug(`${debugPrefix} hasAccess to systemobject`, systemObjectId, hasAccess);
    return hasAccess;
  }

  return {
    isAuth,
    loadDbsAndRole, curUserDbsAndRoles,
    userName, isGlobalAdmin, hasAccessToDatabaseObject
  }
})
